import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stillquestions',
  templateUrl: './stillquestions.component.html',
  styleUrls: ['./stillquestions.component.css']
})
export class StillquestionsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
